import { render, staticRenderFns } from "./NewFinanceClient.vue?vue&type=template&id=393beeda&scoped=true&"
import script from "./NewFinanceClient.vue?vue&type=script&lang=js&"
export * from "./NewFinanceClient.vue?vue&type=script&lang=js&"
import style0 from "./NewFinanceClient.vue?vue&type=style&index=0&id=393beeda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "393beeda",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
